import dbx from '@/dropboxConfig';

const state = {
  usersFullAccount: {},
  structure: [],
};

const getters = {
  usersFullAccount(state) {
    return state.usersFullAccount;
  },
  loggedIn(state) {
    return !!state.usersFullAccount.account_id;
  },
  structure(state) {
    return state.structure;
  },
};

const mutations = {
  SET_USERS_FULL_ACCOUNT(state, data) {
    state.usersFullAccount = data;
  },
  SET_STRUCTURE(sate, data) {
    state.structure = data;
  },
};

const actions = {
  async fetchUserProfile({ commit }) {
    const acct = await dbx.usersGetCurrentAccount();
    commit('SET_USERS_FULL_ACCOUNT', acct);
  },

  clearState({ commit }) {
    commit('SET_USERS_FULL_ACCOUNT', {});
  },

  async fetchStructure({ commit }) {
    const response = await dbx.filesListFolder({
      path: '',
      recursive: true,
      include_mounted_folders: true,
    });
    commit('SET_STRUCTURE', response.entries);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};
